import { toast } from "react-toastify";

import { i18n } from "../../translate/i18n";
import toastError from "../../errors/toastError";

const KNOWN_COMPANY_ERRORS = [
	"ERR_EMAIL_ALREADY_EXISTS",
	"ERR_CANNOT_DEACTIVATE_DEFAULT_COMPANY",
	"ERR_USER_LIMIT_REACHED",
	"ERR_CONNECTION_LIMIT_REACHED",
	"ERR_COMPANY_INACTIVE",
];

/**
 * Mostra uma mensagem amigável para os erros ERR_* do módulo de empresas.
 * Cai no toastError padrão para qualquer outro erro.
 */
const toastCompanyError = (err) => {
	const code = err?.response?.data?.error || err?.response?.data?.message;
	if (
		code &&
		KNOWN_COMPANY_ERRORS.includes(code) &&
		i18n.exists(`companies.errors.${code}`)
	) {
		toast.error(i18n.t(`companies.errors.${code}`), { toastId: code });
		return;
	}
	toastError(err);
};

export default toastCompanyError;
